// This custom made extension to enable creation of marimekko charts in highcharts v4.1.4
// Marimekko chart type is variation of column chart type with addition of "z" value for all points
(function (sb) {
    'use strict';

    var H = Highcharts;

    function isMarimekkoSeries(series) {
        return series.type === "column" && series.data.filter(function (el) { return el.z != null; }).map(function (el) { return el.z; }).length !== 0;
    }

    function getRelZ(data) {
        return data.map(function (dp) { return dp.z; }).slice();
    }

    function getTotalZ(data) {
        return data.reduce(function (a, b) { return a + b; });
    }

    function postTranslate(index, x, relZ, xAxis, isFirstColumn) {
        var i,
            totalZ = getTotalZ(relZ);

        relZ.pop();
        for (i = 0; i < relZ.length; i++) {
            if (i === 0) continue;
            relZ[i] += relZ[i - 1];
        }
        relZ.unshift(x);

        var len = xAxis.len,
            linearSlotLeft = index / relZ.length * len,
            linearSlotRight = (index + 1) / relZ.length * len,
            slotLeft = isFirstColumn ? -0.5 : (H.pick(relZ[index], totalZ) / totalZ) * len,
            slotRight = isFirstColumn ? (H.pick(relZ[index + 1], totalZ) / totalZ) * len - 0.5 : (H.pick(relZ[index + 1], totalZ) / totalZ) * len,
            xInsideLinearSlot = x - linearSlotLeft;

        return slotLeft + xInsideLinearSlot * (slotRight - slotLeft) / (linearSlotRight - linearSlotLeft);
    }

    function translatePoint(point, i, xAxis) {
        // Distort the points to reflect z dimension
        var left, right;

        left = postTranslate(i, point.shapeArgs.x, getRelZ(point.series.data), xAxis, i === 0);
        right = postTranslate(i, point.shapeArgs.x + point.shapeArgs.width, getRelZ(point.series.data), xAxis, i === 0);

        point.shapeArgs.x = left;
        point.shapeArgs.width = right - left;

        // Adjust the tooltip position
        point.tooltipPos[0] = point.shapeArgs.x + point.shapeArgs.width / 2;
    }

    function getShareValue(zData, index) {
        var currZ = zData[index],
            totalZ = zData.reduce(function (a, b) { return a + b; });

        return currZ * 100 / totalZ;
    }

    function getShareValuLabelProperties(chart, point) {
        var padding = 4;
        var fntSize = chart.series[0].userOptions.dataLabels.style.fontSize || '10px';
        return {
            x: chart.plotLeft + point.shapeArgs.x + point.shapeArgs.width / 2 - parseInt(fntSize),
            y: chart.plotTop - padding,
            shape: 'callout',
            anchorX: null,//chart.plotLeft + point.plotX,
            anchorY: null,//chart.plotTop + point.plotY,
            fontSize: fntSize,
            fontWeight: 'bold',
            textShadow: 'none',
            color: chart.series[0].userOptions.dataLabels.color
        };
    }

    function getShareValueLabelText(origValue, unitPrefix, unitSuffix, showYUnitText, noOfDecimals) {
        var labelText = origValue.toFixed(noOfDecimals);

        if (unitPrefix && showYUnitText)
            labelText = unitPrefix + labelText;
        else if (unitSuffix && showYUnitText)
            labelText += unitSuffix;

        return labelText;
    }

    // Taken from  https://awik.io/determine-color-bright-dark-using-javascript/ with minor modifications
    function checkIfLightColor(color) {

        // Variables for red, green, blue values
        var r, g, b, hsp;

        // Check the format of the color, HEX or RGB?
        if (color.match(/^rgb/)) {

            // If HEX --> store the red, green, blue values in separate variables
            color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);

            r = color[1];
            g = color[2];
            b = color[3];
        } else {
            // If RGB --> Convert it to HEX: http://gist.github.com/983661
            color = +("0x" + color.slice(1).replace(
                color.length < 5 && /./g, '$&$&'));

            r = color >> 16;
            g = color >> 8 & 255;
            b = color & 255;
        }

        // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
        hsp = Math.sqrt(
            0.299 * (r * r) +
            0.587 * (g * g) +
            0.114 * (b * b)
        );

        // Using the HSP value, determine whether the color is light or dark
        return hsp > 127.5 ? true : false;
    }

    function renderShareValues(chart) {
        var series = chart.series[0],
            data = series.data,
            seriesOptions = series.userOptions,
            yAxisOptions = chart.yAxis[0].userOptions,
            zData = data.map(function (point) { return point.z; });

        series.points.forEach(function (point, index) {
            var shareValue = getShareValue(zData, index),
                label = getShareValuLabelProperties(chart, point);

            label.text = getShareValueLabelText(shareValue, yAxisOptions.unitPrefix, yAxisOptions.unitSuffix, data[0].showYUnitText, seriesOptions.noOfDecimals);

            var labelColor = label.color;
            if (chart.options.chbUseTwoColorLogic)
                labelColor = checkIfLightColor(chart.options.chart.backgroundColor) ? chart.options.txtLabelColorForLightBg : chart.options.txtLabelColorForDarkBg;

            chart.renderer
                .label(label.text, label.x, label.y, label.shape, label.anchorX, label.anchorY, false, true)
                .css({
                    fontSize: label.fontSize,
                    fontWeight: label.fontWeight,
                    color: labelColor,
                    textShadow: label.textShadow
                })
                .add();
        });
    }

    function getIgnoredChartStyles() {
        return [
            'chart_plotBackgroundColor',
            'xAxis_gridLineWidth', 'xAxis_gridLineColor', 'xAxis_gridLineDashStyle',
            'yAxis_gridLineWidth', 'yAxis_gridLineColor', 'yAxis_gridLineDashStyle'
        ];
    }

    H.wrap(H.seriesTypes.column.prototype, 'translate', function (proceed) {
        proceed.call(this);

        if (isMarimekkoSeries(this.chart.series[0])) {
            this.points.forEach(function (point, i) {
                translatePoint(point, i, this.xAxis);
            }, this);
        }
    });

    H.seriesTypes.column.prototype.postTranslate = function (index, x, relZ, firstAxisLabel) {
        return postTranslate(index, x, relZ, this.xAxis, firstAxisLabel);
    };

    H.Tick.prototype.postTranslate = function (xy, xOrY, index) {
        var axis = this.axis,
            pos = xy[xOrY] - axis.pos,
            data = axis.series[0].userOptions.data;
        //console.log(axis.labelOffset)

        // return if not marimekko series
        if (!isMarimekkoSeries(axis.series[0].userOptions))
            return;

        if (!axis.horiz) {
            pos = axis.len - pos;
        }

        var padding = 1;
        pos = axis.series[0].postTranslate(index, pos - padding, getRelZ(data), index === 0);

        xy[xOrY] = axis.pos + pos;
    };

    H.wrap(H.Tick.prototype, 'getLabelPosition', function (proceed, x, y, label, horiz, labelOptions, tickmarkOffset, index) {
        var args = Array.prototype.slice.call(arguments, 1),
            xy,
            xOrY = horiz ? 'x' : 'y';

        xy = proceed.apply(this, args);

        // Post-translate
        if (this.axis.categories) {
            this.postTranslate(xy, xOrY, index);
        }
        return xy;
    });

    return sb.MarimekkoChart = {
        isMarimekko: isMarimekkoSeries,
        getIgnoredChartStyles: getIgnoredChartStyles,
        renderShareValues: renderShareValues
    };

})(window.Storyboard = window.Storyboard || {});